import { api } from '../configs/axiosConfigs';

export const getListUpload = async (id: string) => {
  return await api.get(`/list-uploads/${id}.json`);
};
